/**
 * Dimension type for formatting functions
 */

export enum Dimension {
  LENGTH = 'length',
  WIDTH = 'width',
  THICKNESS = 'thickness'
}
